import React from 'react'
import CarInfo from './CarInfo'

function UserCar() {
  return <CarInfo isUser />
}

export default UserCar
